module.exports = __webpack_public_path__ + "media/images/menu/serpens-9ea3cce1d4e8d76e9cedf2f3b7814302.jpg";